import axios from 'axios'
import type { ApiError } from '@/utils/types'
import { FALLBACK_API_ERROR } from '@/utils/consts'
import { ref } from 'vue'

export const useRequestFactory = <ActT extends string>() => {
  const loading = ref<Record<ActT, boolean>>({} as Record<ActT, boolean>)
  const errors = ref<Record<ActT, ApiError | null>>({} as Record<ActT, ApiError | null>)

  const requestHandler = async <T>(
    actionId: string,
    callback: (...args: unknown[]) => Promise<T>,
  ) => {
    loading.value[actionId] = true
    try {
      const result = await callback()
      if (errors.value?.[actionId]) delete errors.value[actionId]
      return result
    } catch (thrown) {
      if (axios.isAxiosError(thrown) && thrown.response) {
        errors.value[actionId] = {
          message: thrown.response?.data,
          code: thrown.response?.status,
        }
      } else {
        errors.value[actionId] = FALLBACK_API_ERROR
      }
    } finally {
      loading.value[actionId] = false
    }
  }

  return {
    requestHandler,
    loading,
    errors,
  }
}
